// extracted by mini-css-extract-plugin
export default {"header":"style_header__qn2aF","mid":"style_mid__Izs+Q","left":"style_left__JEE4K"};